const defaultState = {
  mapLayers: [],
  isLoading: false,
  error: false,
};

const trackerMap = function (state = defaultState, action) {
  switch (action.type) {
    case 'ADD_MAP_LAYER':
      return { ...state, mapLayers: [...state.mapLayers, action.data] };

    case 'REMOVE_MAP_LAYER':
      let { mapLayers } = state;
      mapLayers = mapLayers.filter((d) => d.layer.id !== action.data);
      return { ...state, mapLayers };

    case 'UPDATE_MAP_LAYER':
      let layers = state.mapLayers;
      let indexOfTargetLayer = layers.findIndex((d) => d.id === action.data.id);
      if (indexOfTargetLayer < 0) return state;
      let targetLayer = layers[indexOfTargetLayer];
      let updatedLayer = {
        ...targetLayer,
        ...action.data.layerUpdates,
        refresh: targetLayer.refresh + 1,
      };
      layers.splice(indexOfTargetLayer, 1, updatedLayer);
      return { ...state, mapLayers: layers };

    case 'CLEAR_MAP_LAYERS':
      return { ...state, mapLayers: [] };

    case 'TRACKER_MAP_IS_LOADING':
      return {
        ...state,
        isLoading: !!action.data,
      };

    case 'TRACKER_MAP_ERROR':
      return {
        ...state,
        error: !!action.data,
      };

    default:
      return state;
  }
};

export default trackerMap;
